type KeyString = {
  [key: string]: string
}

export function getAdvancedFilterRuleLabelFeedback(condition: string, label: string) {
  const possibleRuleLabelFeedbacks: KeyString = {
    EQUAL: `${label}`,
    HAVE: `${label}`,
    NOT_HAVE: `${label}: não possui`,
    GREATHER_THAN: `${label}: maior que`,
    LOWER_THAN: `${label}: menor que`,
  }

  if (!condition) return label

  return possibleRuleLabelFeedbacks[condition]
}
